import Vue from 'vue';
import { FormatUtility } from '@codequality/vue-cli-base';

import AppFormatUtility from '@/classes/common/AppFormatUtility';

// 日時整形（'YYYY/MM/DD/HH:mm'形式）
Vue.filter('appDtf', (value?: string | null): string => {
  return FormatUtility.toYmdhms(value, 'YYYY/MM/DD/HH:mm');
});

// 年月整形（'YYYY/MM'形式）
Vue.filter('ymf', (value?: string | number | null): string => {
  return AppFormatUtility.formatYm(value);
});

// 年月整形（'YYYY年M月'形式）
Vue.filter('年月', (value?: string | number | null): string => {
  return AppFormatUtility.format年月(value);
});

// 年月期整形（'YYYY年M月期'形式）
Vue.filter('年月期', (value?: string | number | null): string => {
  return AppFormatUtility.format年月期(value);
});

// 単位切り替え（四捨五入）
Vue.filter('unit', (value: number, unit: number | null): number => {
  return AppFormatUtility.changeUnit(value, unit);
});
